export default __webpack_public_path__ + "static/media/warning.34bd48a3.svg";